/* Nolae — FAQ, editable version (sections/nolae-faq-content.liquid).
   The answers come from the page's Content field, written in the admin
   editor, so they arrive plain. This does to them what the generated
   version had baked in:
     * prices (4,95€ / €8.95 …) get the storefront's price style;
     * links open in a new tab, except #anchors on this page;
     * table cells get their mobile labels (the header above them);
     * a video added later (no length / poster known to the theme) gets
       them from Vimeo. */
(function () {
  var root = document.querySelector(".nolae-faq");
  if (!root) return;

  var PRICE = /€\s?\d+(?:[.,]\d{2})?|\d+(?:[.,]\d{2})?\s?€/g;
  [].forEach.call(root.querySelectorAll(".faq-a-body"), function (body) {
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (p.closest(".faq-price, table, .tm-card, script, style")) return NodeFilter.FILTER_REJECT;
        PRICE.lastIndex = 0;
        return PRICE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var frag = document.createDocumentFragment(), s = n.nodeValue, last = 0, m;
      PRICE.lastIndex = 0;
      while ((m = PRICE.exec(s))) {
        frag.appendChild(document.createTextNode(s.slice(last, m.index)));
        var span = document.createElement("span");
        span.className = "faq-price";
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      frag.appendChild(document.createTextNode(s.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });

    [].forEach.call(body.querySelectorAll("a[href]"), function (a) {
      if (a.getAttribute("href").charAt(0) === "#") return;
      a.target = "_blank";
      a.rel = "noopener";
    });

    [].forEach.call(body.querySelectorAll("table"), function (t) {
      var heads = t.querySelectorAll("thead tr:last-child th");
      [].forEach.call(t.querySelectorAll("tbody tr"), function (tr) {
        var tds = tr.querySelectorAll("td");
        // The price cells are the last ones; they line up with the last header row.
        var off = tds.length - heads.length;
        [].forEach.call(tds, function (td, i) {
          if (i >= off && off >= 0 && !td.hasAttribute("data-label")) td.setAttribute("data-label", heads[i - off].textContent.trim());
        });
      });
    });
  });

  [].forEach.call(root.querySelectorAll('.tm-card--video[data-duration="0"]'), function (card) {
    var frame = card.querySelector("iframe[data-vimeo]");
    if (!frame || !window.fetch) return;
    fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent("https://vimeo.com/" + frame.getAttribute("data-vimeo")))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (o) {
        if (!o) return;
        if (o.duration) {
          card.setAttribute("data-duration", o.duration);
          var t = card.querySelector(".faq-vtime"), now = card.querySelector(".faq-vtime-now");
          var clock = Math.floor(o.duration / 60) + ":" + ("0" + (o.duration % 60)).slice(-2);
          if (t && now) { t.textContent = " / " + clock; t.insertBefore(now, t.firstChild); }
        }
        if (o.width && o.height) frame.style.setProperty("--va", "calc(" + o.width + " / " + o.height + ")");
        var img = card.querySelector("img.v-poster");
        if (img && o.thumbnail_url && !img.getAttribute("src")) img.src = o.thumbnail_url;
      })
      .catch(function () {});
  });
})();
